function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import cn from 'classnames';
import React, { FC } from 'react';
require("./RatingNumber.css");
var styles = {
  "RatingNumber": "RatingNumber-module-RatingNumber_FUe",
  "Value": "RatingNumber-module-Value_wJL"
};
import { IRatingBaseProps } from '../Rating';
import { RatingStar } from '../Star/RatingStar';
export const RatingNumber = ({
  max = 5,
  filled = true,
  value,
  className,
  style,
  innerRef,
  controlRef,
  tag: Component = 'div',
  ...props
}) => {
  value = Math.min(value, max);
  let fullness = filled ? 1 : value / max;
  let preparedValue = value.toFixed(1).toString().replace('.', ',');
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cn(styles.RatingNumber, className),
    style: style,
    ref: innerRef || controlRef,
    role: "img",
    "aria-label": `Рейтинг ${value} из ${max}`
  }, props), /*#__PURE__*/React.createElement(RatingStar, {
    fullness: fullness
  }), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: styles.Value
  }, preparedValue));
};
if (process.env.NODE_ENV !== 'production') {
  RatingNumber.displayName = 'RatingNumber';
}